import React, { memo } from 'react';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { useSite, withSite } from 'components/dataProviders/withSite';
import { SingleSite } from 'components/site/single';
import { Spinner } from 'components/core';
import { useLevels } from 'store/level';
import { MemoCreateLevelWizardDialog } from 'views/level/wizard/create/dialog';
import { MemoEditLevelWizardDialog } from 'views/level/wizard/edit/dialog';
import {
  useCreateLevel,
  withCreateLevel,
} from 'components/dataCreationForms/level/withCreateLevel';
import {
  useEditLevel,
  withEditLevel,
} from 'components/dataCreationForms/level/withEditLevel';

const SiteView = (): React.ReactElement | null => {
  const { site, loading } = useSite();
  const { deleteLevel, restoreLevel, canDeleteLevel } = useLevels();
  const { openDialog: openCreateLevelDialog } = useCreateLevel();
  const { openDialog: openEditLevelDialog } = useEditLevel();

  if (loading) {
    return <Spinner reason='SiteView loading' />;
  }

  if (!site) {
    return null;
  }

  return (
    <>
      <SingleSite
        {...site}
        openCreateLevelDialog={openCreateLevelDialog}
        openEditLevelDialog={openEditLevelDialog}
        deleteLevel={deleteLevel}
        canDeleteLevel={canDeleteLevel}
        restoreLevel={restoreLevel}
      />
      <MemoCreateLevelWizardDialog />
      <MemoEditLevelWizardDialog />
    </>
  );
};

export const MemoSiteView = memo(
  composeHOCs(
    withSite,
    withCreateLevel,
    withEditLevel
  )(SiteView)
);
